import {connect, useSelector} from "react-redux";
import React, {useRef, useState} from "react";
import {getCkProductBrandMappingList, updateProductBrandMapping} from "../../../../api/api";
import {
    CButton,
    CCol,
    CForm, CFormInput,
    CInputGroup,
    CInputGroupText
} from "@coreui/react";
import {Loading} from "../../../../components/common";
import {AgGridReact} from "ag-grid-react";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";

const ProductBrandMapping = (props) => {
    const { user } = useSelector((props) => props.account);
    const gridRef = useRef();
    const [activeKey, setActiveKey] = useState(1);
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [searchForm, setSearchForm] = useState({cmpCd: "", brandCd: "", storeCd: "", restProductCd: "", productNm: "", barcode: "", brandProductCd:""});

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true,
        enableRangeSelection: true,
        rowSelection: 'multiple',
        enableCellTextSelection: false
    };

    const [columnDefs] = useState([
        { field: "cmpCd", hide: true },
        { field: "productCd", hide: true },
        { field: "restProductCd", headerName: "상품코드" },
        { field: "productNm", headerName: "상품명" },
        { field: "sourceCd", headerName: "바코드" },
        { field: "brandProductCd", headerName: "브랜드연결코드", editable: true, cellEditor: 'agTextCellEditor', },
        { field: "useYn", hide: true }
    ])

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code, storeCd: "", cornerCd: ""
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code, cornerCd: ""
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    }

    const search = () => {
        props.onError({visible: false, message: ""})

        const { cmpCd, brandCd, storeCd } = searchForm;
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            restProductCd: searchForm.restProductCd,
            productNm: searchForm.productNm,
            barcode: searchForm.barcode,
            brandProductCd: searchForm.brandProductCd
        };
        console.log(">>> 조회 params :: ", params);

        if(storeCd.length === 0) {
            alert("점포를 먼저 선택해주세요.");
            return;
        }

        props.onLoading(true);
        getCkProductBrandMappingList(params).then((result) => {
            const { responseBody } = result.data;
            setRowData(responseBody);
        })
            .catch((e) => {
                props.onError({visible: true, message: e.message})
            })
            .finally(() => {
                props.onLoading(false);
            })
    }

    const save = () => {
        if (confirm("저장하시겠습니까?")) {
            gridRef.current.api.stopEditing();

            // 딜레이를 주자
            setTimeout(() => {
                console.log(">>> rows :: ", updateRows);

                updateProductBrandMapping(updateRows).then((result) => {
                    const {responseBody, responseCode, responseMessage, responseStatus} = result.data;

                    if (responseCode === "200") {
                        alert("처리되었습니다.");
                        search();
                    } else { //저장 실패 시!
                        alert(responseMessage+ "\n기존 브랜드연결코드를 삭제 후 저장해주세요.");
                    }
                })
            }, 200)
        }
    }

    let updateRows = [];
    const getUpdateRows = (e) => {
        if (e.oldValue !== e.newValue) {
            const data = {
                cmpCd: e.data.cmpCd,
                brandCd: e.data.brandCd,
                storeCd: e.data.storeCd,
                productCd: e.data.productCd,
                restProductCd: e.data.restProductCd,
                sourceCd: e.data.sourceCd,
                brandProductCd: e.data.brandProductCd,
                oldBrandProductCd: e.oldValue
            }
            console.log("쌓인 데이터 data :: " , data);
            updateRows.push(data);
        }
    }

    const onCellEditingStopped = (e) => {
        getUpdateRows(e);
    }

    return (
        <>
            <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
            <CForm className="row row-cols-lg-auto p-1 g-1">
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 100}}>상품코드</CInputGroupText>
                        <CFormInput id="productCd"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            restProductCd: e.target.value
                                        }));
                                    }}/>
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 80}}>상품명</CInputGroupText>
                        <CFormInput id="productNm"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            productNm: e.target.value
                                        }));
                                    }}
                        />
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                <CInputGroup className={"mb-1"} size={"sm"}>
                    <CInputGroupText style={{width: 80}}>바코드</CInputGroupText>
                    <CFormInput id="barcode"
                                onChange={(e) => {
                                    setSearchForm((state) => ({
                                        ...state,
                                        barcode: e.target.value
                                    }));
                                }}/>
                </CInputGroup>
            </CCol>
            <CCol xs={12}>
                <CInputGroup className={"mb-1"} size={"sm"}>
                    <CInputGroupText style={{width: 120}}>브랜드연결코드</CInputGroupText>
                    <CFormInput id="barcode"
                                onChange={(e) => {
                                    setSearchForm((state) => ({
                                        ...state,
                                        brandProductCd: e.target.value
                                    }));
                                }}/>
                </CInputGroup>
            </CCol>
                <div className="d-grid gap-1 d-md-flex justify-content-md-end align-items-center">
                    <CButton size={"sm"} color="dark" onClick={search}>조회</CButton>
                    <CButton size={"sm"} color="dark" onClick={save}>저장</CButton>
                </div>
            </CForm>
            <div className="ag-theme-alpine" style={{ width: "100%", height: 500, marginTop: 10 }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    animateRows={true}
                    pagination={true}
                    singleClickEdit={true}
                    enableRangeSelection={true}
                    enableCellTextSelection={true}
                    suppressClipboardPaste={true}
                    onCellEditingStopped={onCellEditingStopped}
                    localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}>
                </AgGridReact>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductBrandMapping);
